/* eslint no-underscore-dangle: ["error", { "allow": ["_root", "_tail"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition,
} from 'griddle-react';
import { Link, browserHistory } from 'react-router';
import Mailto from 'react-mailto';
import _ from 'lodash';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { Dialog, FlatButton } from 'material-ui';

import classes from './Person.scss';

import urldecode from '../../../helpers/urldecode';
import caseInsensitiveSort from '../../../helpers/caseInsensitiveSort';
import ContactCard from '../../../components/ContactCard/ContactCard';

class Person extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }

  componentDidMount() {
    this.props.fetchPerson();
  }

  prepareData = dataArray => {
    const newData = [];
    _.forOwn(dataArray, data => {
      // create new object that will be handled by griddle
      let phone = '';
      if (
        typeof data.meta !== 'undefined' &&
        typeof data.meta.tel !== 'undefined' &&
        typeof data.meta.tel.value !== 'undefined' &&
        data.meta.tel.value !== null
      ) {
        phone = data.meta.tel.value;
      } else if (
        typeof data.cd_phone !== 'undefined' &&
        data.cd_phone !== null
      ) {
        phone = data.cd_phone;
      }

      let email = '';
      if (typeof data.email !== 'undefined' && data.email !== null) {
        email = data.email;
      } else if (
        typeof data.cd_email !== 'undefined' &&
        data.cd_email !== null
      ) {
        email = data.cd_email;
      }

      const company = {
        id: 'companies',
        value: data.companies,
      };

      let position = '';
      if (
        typeof data.meta !== 'undefined' &&
        typeof data.meta.position !== 'undefined' &&
        data.meta.position.value !== null
      ) {
        position = data.meta.position.value;
      }

      const person = `${data.name}:-:${data.id}:-:${urldecode(data.avatar)}:-:${
        data.avatar_id
      }`;

      if (typeof data.deleted_at === 'undefined' || data.deleted_at === null) {
        if (typeof data.name !== 'undefined') {
          newData.push({
            id: data.id,
            person,
            phone,
            email,
            company,
            position,
          });
        }
      }
    });
    return newData;
  };

  renderAvatarAndName = data => {
    const values = _.split(data.value, ':-:');
    const name = values[0];
    const id = values[1];
    const avatar = values[2];
    const avatarId = values[3];

    return (
      <ContactCard
        id={id}
        name={name}
        avatar={avatar}
        avatarId={avatarId}
        type="person"
        displayType="normal"
      />
    );
  };

  renderMail = data => {
    if (typeof data.value === 'undefined' || data.value === null) {
      return <span />;
    }

    return <Mailto email={data.value}>{data.value}</Mailto>;
  };

  renderCompany = data => {
    if (
      typeof data.value._root.entries[1][1] === 'undefined' ||
      data.value._root.entries[1][1].size === 0
    ) {
      return <span />;
    }
    // const companyIds = data.value._root.entries[1][1]._tail.array;
    const pickedCompanies = _.pick(
      this.props.companies,
      data.value._root.entries[1][1]._tail.array,
    );

    const companies = [];

    _.forOwn(pickedCompanies, data => {
      companies.push(
        <Link to={`/company/${data.id}`} key={`person_company_link_${data.id}`}>
          {data.name}
        </Link>,
      );
    });

    return <span className={classes.companyLinks}>{companies}</span>;
  };

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderOverflow = data => (
    <IconMenu
      iconButtonElement={
        <IconButton>
          <MoreVertIcon />
        </IconButton>
      }
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      targetOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      <MenuItem
        primaryText="Bearbeiten"
        leftIcon={<EditIcon />}
        onTouchTap={e => this.props.setPersonForm(data.value)}
      />
      <Divider />
      <MenuItem
        primaryText="Kontakt löschen"
        leftIcon={<DeleteIcon className="svg-icon-primary svg-icon-warning" />}
        key="delPerson"
        className="menu-primary"
        onClick={() => {
          this.setState({
            alert: (
              <Dialog
                actions={[
                  <FlatButton
                    label="Abbrechen"
                    primary
                    onTouchTap={this.handleAlertClose}
                  />,
                  <FlatButton
                    label="Löschen"
                    primary
                    onTouchTap={() => {
                      this.handleAlertClose();
                      this.props.deletePerson(data.value);
                      browserHistory.push('/person');
                    }}
                  />,
                ]}
                modal={false}
                open
                onRequestClose={this.handleAlertClose}
              >
                Kontakt wirklich löschen?
              </Dialog>
            ),
          });
        }}
      />
    </IconMenu>
  );

  renderLinksMobile = dataArray => {
    const links = [];

    _.forOwn(dataArray, value => {
      links.push(
        <div key={`mobile_link_${value.id}`}>
          <ContactCard
            id={value.id}
            name={value.name}
            avatar={value.avatar}
            type="person"
            displayType="normal"
          />
        </div>,
      );
    });

    return links;
  };

  render() {
    const props = this.props;
    const components = {
      NoResults: () => (
        <div>
          <p className="text-center">
            <small>Keine Kontakte eingetragen.</small>
          </p>
        </div>
      ),
    };
    const sortProperties = [
      {
        id: 'person',
        sortAscending: true,
      },
    ];

    if (window.innerWidth < 767) {
      return (
        <div className="wrapper">
          <div>
            <h2 className={`${classes.zenHeader} gutter`}>Kontakte</h2>

            <div className="mobile-list">
              {this.renderLinksMobile(props.persons)}
            </div>
          </div>
        </div>
      );
    }

    const data = this.prepareData(props.persons);
    return (
      <div className="wrapper">
        <div>
          <h2 className="gutter">{data.length} Kontakte</h2>

          <Griddle
            data={data}
            plugins={[plugins.LocalPlugin]}
            pageProperties={{
              pageSize: 5000,
            }}
            components={components}
            sortProperties={sortProperties}
            sortMethod={caseInsensitiveSort}
          >
            <RowDefinition keyColumn="id">
              <ColumnDefinition
                id="id"
                title="ID"
                cssClassName="text-right"
                visible={false}
              />
              <ColumnDefinition
                id="person"
                title="Name"
                customComponent={this.renderAvatarAndName}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition id="phone" title="Telefon" />
              <ColumnDefinition
                id="email"
                title="E-Mail"
                customComponent={this.renderMail}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="company"
                title="Unternehmen"
                customComponent={this.renderCompany}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="position"
                title="Position"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="id"
                title=" "
                sortable={false}
                width={70}
                cssClassName="OverFlowButton text-right"
                customComponent={this.renderOverflow}
              />
            </RowDefinition>
          </Griddle>

          {this.state.alert}
        </div>

        <div className="importer text-center">
          <p>
            Sie koennen jetzt auch Kontakte aus Ihrem Google Addressbuch
            importieren! Fuer weitere Informationen klicken Sie bitte{' '}
            <Link to="person/import">hier</Link>.
          </p>
        </div>
      </div>
    );
  }
}
Person.propTypes = {
  fetchPerson: PropTypes.func.isRequired,
  setPersonForm: PropTypes.func.isRequired,
  deletePerson: PropTypes.func.isRequired,
  person: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  persons: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
  companies: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
};
export default Person;



// WEBPACK FOOTER //
// ./src/routes/Person/components/Person.js